export default "__VITE_ASSET__Bj9x$d2T__"